// @flow
import SourceItemContainer from './containers/SourceItemContainer';

export default SourceItemContainer;